import clsx from 'clsx';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { fontWeights, fontSize as fontSizes } from '@ovpn-ui/styles';
import * as Styled from './Button.styles';
import { defaultElement } from './Button.props';

// TODO this is ultra-stupid hack,
// because button type system is completely broken (\/) (°,,,,°) (\/)
// Need to refactor button types
import { jsx as _jsx } from "react/jsx-runtime";
// We want to preventDefault in case of disabled anchor tag
const preventDefault = e => e.preventDefault();
function getDefaultBoxProps(size) {
  switch (size) {
    case 'sm':
      return {
        fontSize: fontSizes.small,
        lineHeight: fontSizes.xMedium,
        minWidth: '46px'
      };
    default:
      return {
        fontSize: fontSizes.default,
        lineHeight: fontSizes.xxMedium,
        minWidth: '56px'
      };
  }
}
function Button(props, ref) {
  const {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    as,
    children,
    // behaviour
    type: _type = 'button',
    onClick: _onClick,
    target,
    href,
    to,
    // state
    isLoading = false,
    disabled = false,
    // appearance
    variant = 'primary',
    size = 'md',
    isWrapped = false,
    // box default props
    flex = true,
    inline = true,
    center = true,
    p = '8px 16px',
    fontWeight = fontWeights.semiBold,
    lineHeight,
    minWidth,
    fullWidth,
    fontSize,
    // accessibility props
    'aria-label': ariaLabel,
    ...htmlAttributes
  } = props;
  const type = disabled || isLoading ? 'button' : _type;
  const onClick = disabled || isLoading ? preventDefault : _onClick;
  const content = isLoading ? /*#__PURE__*/_jsx(Styled.Spinner, {
    className: "ovpn-button-spinner",
    size: size,
    variant: variant
  }) : children;
  const defaultBoxProps = getDefaultBoxProps(size);
  const boxProps = {
    flex,
    inline,
    center,
    fullWidth,
    fontWeight,
    p,
    fontSize: fontSize || defaultBoxProps.fontSize,
    lineHeight: lineHeight || defaultBoxProps.lineHeight,
    minWidth: minWidth || defaultBoxProps.minWidth
  };
  const commonProps = {
    onClick,
    ref,
    $isLoading: isLoading,
    $isWrapped: isWrapped,
    variant,
    size,
    tabIndex: isLoading || disabled ? -1 : undefined,
    'aria-disabled': disabled ? true : undefined,
    ...htmlAttributes,
    ...boxProps
  };
  if (to) {
    const className = clsx('mchNoDecorate', commonProps.className);
    return /*#__PURE__*/_jsx(Styled.Button, {
      forwardedAs: Link,
      to: to,
      ...commonProps,
      className: className
      // ariaPressed is passed after commonProps to prevent from setting ariaPressed
      // because in this case button will be rendered as an "a" tag
      ,
      "aria-pressed": undefined,
      "aria-label": ariaLabel,
      children: content
    });
  }
  if (href) {
    return /*#__PURE__*/_jsx(Styled.Button, {
      forwardedAs: "a",
      href: href,
      target: target,
      ...commonProps,
      // ariaPressed is passed after commonProps to prevent from setting ariaPressed
      // because in this case button will be rendered as an "a" tag
      "aria-pressed": undefined,
      "aria-label": ariaLabel,
      children: content
    });
  }
  return /*#__PURE__*/_jsx(Styled.Button, {
    forwardedAs: defaultElement,
    type: type,
    ...commonProps,
    "aria-label": ariaLabel,
    children: content
  });
}
export default /*#__PURE__*/React.forwardRef(Button);